module.exports = __webpack_public_path__ + "static/media/F5aug.3dbc89ed.wav";